import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { QuoteIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 bg-white" data-id="element-152">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
        <FadeIn data-id="element-154">
          <div className="relative bg-sage rounded-[2.5rem] p-10 md:p-16 text-center overflow-hidden" data-id="element-155">
            {/* Decorative background */}
            <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-156">
              <div className="absolute -top-10 -left-10 w-40 h-40 rounded-full bg-white blur-2xl" data-id="element-157" />
              <div className="absolute -bottom-10 -right-10 w-40 h-40 rounded-full bg-white blur-2xl" data-id="element-158" />
            </div>

            <QuoteIcon className="w-16 h-16 text-white/20 mx-auto mb-8 rotate-180" data-id="element-159" />

            <p className="text-2xl md:text-3xl lg:text-4xl font-serif text-white leading-relaxed mb-8 relative z-10" data-id="element-160">
              En los primeros 7 días, lo primero que notarás no es solo el
              vientre más plano; es el{' '}
              <span className="font-bold italic text-gold-light" data-id="element-161">
                "silencio mental"
              </span>
              .
            </p>

            <p className="text-lg md:text-xl text-white/90 relative z-10 max-w-2xl mx-auto" data-id="element-162">
              Esa neblina matutina desaparece y recuperas la calma interna que
              permite que tu metabolismo funcione sin frenos de mano.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}